import React from "react";

const MessageA24 = (props) => {
  return (
    <>
      <div className="chat-text" style={{ margin: "10px 0px", color: "red" }}>
        {props.item.text}{" "}
      </div>
    </>
  );
};

export default MessageA24;
